import { render } from "./ControlPanel.vue?vue&type=template&id=31da2d61&scoped=true"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"

import "./ControlPanel.vue?vue&type=style&index=0&id=31da2d61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31da2d61"]])

export default __exports__